/**
 * @generated SignedSource<<3c5699b07ab0b5fde557e9255507e716>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BadgeKind = "emoji" | "icon" | "upload" | "%future added value";
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type DashboardBlockKind = "banner" | "channels" | "collection_folder" | "community_welcome_hero" | "content" | "continue_your_products" | "curriculum" | "experience_details" | "featured_items" | "feed" | "hero" | "leaderboard" | "members_list" | "memberships" | "pathway_sequence" | "product_admin" | "recently_viewed" | "rich_text" | "upcoming_events" | "welcome_banner" | "%future added value";
export type DashboardLayout = "one_column" | "two_column" | "%future added value";
export type FeedAllowPostsFrom = "admins" | "all" | "groups" | "%future added value";
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type ProductAppStatus = "active" | "inactive" | "%future added value";
export type ProductAppVisibility = "admin" | "all" | "membership" | "%future added value";
export type CreateProductAppInput = {
  allowPostsFrom?: FeedAllowPostsFrom | null;
  allowPostsGroups?: ReadonlyArray<string> | null;
  allowPostsMembers?: ReadonlyArray<string> | null;
  appDirectoryItems?: ReadonlyArray<AppDirectoryItemInput> | null;
  badge?: BadgeInput | null;
  contentId?: string | null;
  contentLabelId?: string | null;
  contentType?: ContentType | null;
  coverPhoto?: string | null;
  customAppDescription?: string | null;
  customAppTitle?: string | null;
  customAppUrl?: string | null;
  dashboardLayout?: DashboardLayout | null;
  kind: ProductAppKind;
  linkProductId?: string | null;
  navFolderId?: string | null;
  navSectionId?: string | null;
  organizationId?: string | null;
  productId?: string | null;
  richEditorContent?: string | null;
  showOnDashboard?: boolean | null;
  skipDefaultModule?: boolean | null;
  systemTaskKind?: ContentSystemTaskKind | null;
  visibility?: ProductAppVisibility | null;
  visibilityGroups?: ReadonlyArray<string> | null;
  visibilityMembers?: ReadonlyArray<string> | null;
};
export type BadgeInput = {
  assetId?: string | null;
  color?: string | null;
  emoji?: string | null;
  icon?: string | null;
  kind: BadgeKind;
  mediaUrl?: string | null;
};
export type AppDirectoryItemInput = {
  memberGroupId: string;
};
export type useAddAppFormStoreMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateProductAppInput;
  isOrgTopLevel?: boolean | null;
};
export type useAddAppFormStoreMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly badge: {
        readonly color: string | null;
        readonly emoji: string | null;
        readonly kind: BadgeKind;
        readonly mediaUrl: string | null;
      };
      readonly collection: {
        readonly id: string;
      } | null;
      readonly contentUsage: {
        readonly id: string;
      } | null;
      readonly customAppTitle: string | null;
      readonly customAppUrl: string | null;
      readonly feed: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly kind: ProductAppKind;
      readonly navSection: {
        readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_NavSectionFragment">;
      } | null;
      readonly navSectionId: string | null;
      readonly ordering: number;
      readonly organization?: {
        readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_OrganizationFragment">;
      };
      readonly product: {
        readonly dashboard: {
          readonly blocks: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly kind: DashboardBlockKind;
                readonly " $fragmentSpreads": FragmentRefs<"DashboardBlockItemFragment">;
              };
            }>;
          };
          readonly id: string;
        } | null;
        readonly id: string;
        readonly slug: string;
        readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_ProductFragment" | "MyExperiencesListItemFragment">;
      } | null;
      readonly showOnDashboard: boolean;
      readonly status: ProductAppStatus;
      readonly visibility: ProductAppVisibility;
      readonly " $fragmentSpreads": FragmentRefs<"AppSidebarItemFragment" | "FeedAppSettingsButtonFragment" | "useRenderProductAppItemFragment">;
    } | null;
  };
};
export type useAddAppFormStoreMutation = {
  response: useAddAppFormStoreMutation$data;
  variables: useAddAppFormStoreMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isOrgTopLevel"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordering",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showOnDashboard",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "navSectionId",
  "storageKey": null
},
v13 = [
  (v4/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Collection",
  "kind": "LinkedField",
  "name": "collection",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emoji",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v19 = [
  {
    "kind": "Literal",
    "name": "position",
    "value": "main"
  }
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentUsage",
  "kind": "LinkedField",
  "name": "contentUsage",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    (v16/*: any*/),
    (v17/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v28 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v30 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v31 = [
  (v30/*: any*/),
  (v29/*: any*/)
],
v32 = {
  "alias": "nullableProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v33 = [
  (v32/*: any*/),
  (v29/*: any*/)
],
v34 = {
  "alias": "nullableProductIdString",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Feed",
  "kind": "LinkedField",
  "name": "feed",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v27/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v28/*: any*/),
            (v29/*: any*/)
          ],
          "type": "Product",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v31/*: any*/),
          "type": "Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v33/*: any*/),
          "type": "Comment",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v33/*: any*/),
          "type": "Feed",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v33/*: any*/),
          "type": "Post",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v34/*: any*/),
            (v29/*: any*/)
          ],
          "type": "ContentUsage",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v33/*: any*/),
          "type": "ChatChannel",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v33/*: any*/),
          "type": "Dashboard",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v31/*: any*/),
          "type": "AssignmentSubmission",
          "abstractKey": null
        }
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ],
  "storageKey": null
},
v36 = [
  (v26/*: any*/)
],
v37 = [
  (v30/*: any*/),
  (v26/*: any*/),
  (v29/*: any*/)
],
v38 = [
  (v32/*: any*/),
  (v26/*: any*/),
  (v29/*: any*/)
],
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v36/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v28/*: any*/),
        (v26/*: any*/),
        (v29/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v34/*: any*/),
        (v26/*: any*/),
        (v29/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v36/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v36/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v40 = {
  "alias": "connectedApps",
  "args": [
    {
      "kind": "Literal",
      "name": "includeNested",
      "value": true
    }
  ],
  "concreteType": "ProductAppNodeConnection",
  "kind": "LinkedField",
  "name": "productApps",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductAppNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productApps(includeNested:true)"
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v25/*: any*/),
    (v39/*: any*/),
    (v4/*: any*/),
    (v24/*: any*/),
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembership",
      "kind": "LinkedField",
      "name": "viewerMembership",
      "plural": false,
      "selections": (v13/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = [
  (v18/*: any*/),
  (v4/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "linkProduct",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalChannelId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductAppNodeConnection",
  "kind": "LinkedField",
  "name": "productApps",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductAppNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ChatChannel",
              "kind": "LinkedField",
              "name": "chatChannel",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v45/*: any*/)
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "forYouDashboard",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatChannel",
  "kind": "LinkedField",
  "name": "chatChannel",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v44/*: any*/),
    (v39/*: any*/),
    (v10/*: any*/),
    (v49/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductAppNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductApp",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          (v8/*: any*/),
          (v35/*: any*/),
          (v41/*: any*/),
          (v14/*: any*/),
          (v20/*: any*/),
          (v43/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v6/*: any*/),
          (v10/*: any*/),
          (v23/*: any*/),
          (v48/*: any*/),
          (v49/*: any*/),
          (v12/*: any*/),
          (v50/*: any*/),
          (v27/*: any*/)
        ],
        "storageKey": null
      },
      (v51/*: any*/)
    ],
    "storageKey": null
  },
  (v52/*: any*/)
],
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showOnMobile",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dashboardId",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitle",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorDescription",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideAfter",
  "storageKey": null
},
v61 = {
  "alias": "richTextBlockTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorContent",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCtaButton",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/)
  ],
  "type": "RichTextDashboardBlock",
  "abstractKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMembers",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showDates",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCountdown",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showProgress",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAttendance",
  "storageKey": null
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    (v67/*: any*/),
    (v68/*: any*/),
    (v69/*: any*/),
    (v70/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/)
  ],
  "type": "ExperienceDetailsDashboardBlock",
  "abstractKey": null
},
v74 = {
  "alias": "contentMode",
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentId",
  "storageKey": null
},
v76 = {
  "kind": "InlineFragment",
  "selections": [
    (v74/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "contentUsages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v75/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentDashboardBlock",
  "abstractKey": null
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    (v75/*: any*/)
  ],
  "type": "CollectionFolderDashboardBlock",
  "abstractKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featuredKind",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductNodeConnection",
  "kind": "LinkedField",
  "name": "featuredProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v13/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v80 = {
  "kind": "InlineFragment",
  "selections": [
    (v70/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/)
  ],
  "type": "FeaturedItemsDashboardBlock",
  "abstractKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    }
  ],
  "type": "HeroDashboardBlock",
  "abstractKey": null
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "leaderboardCount",
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": "leaderboardTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": "leaderboardDescription",
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": "leaderboardLookbackWindow",
      "args": null,
      "kind": "ScalarField",
      "name": "lookbackWindow",
      "storageKey": null
    },
    {
      "alias": "leaderboardView",
      "args": null,
      "kind": "ScalarField",
      "name": "view",
      "storageKey": null
    }
  ],
  "type": "LeaderboardDashboardBlock",
  "abstractKey": null
},
v83 = {
  "alias": "membersListCount",
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberType",
  "storageKey": null
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    (v83/*: any*/),
    (v84/*: any*/)
  ],
  "type": "MembersListDashboardBlock",
  "abstractKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventType",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCover",
  "storageKey": null
},
v89 = {
  "alias": "eventsView",
  "args": null,
  "kind": "ScalarField",
  "name": "view",
  "storageKey": null
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    (v86/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/),
    (v89/*: any*/)
  ],
  "type": "UpcomingEventsDashboardBlock",
  "abstractKey": null
},
v91 = {
  "alias": "feedTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v92 = {
  "alias": "feedView",
  "args": null,
  "kind": "ScalarField",
  "name": "view",
  "storageKey": null
},
v93 = {
  "alias": "feedShowCover",
  "args": null,
  "kind": "ScalarField",
  "name": "showCover",
  "storageKey": null
},
v94 = {
  "kind": "InlineFragment",
  "selections": [
    (v91/*: any*/),
    (v92/*: any*/),
    (v93/*: any*/)
  ],
  "type": "FeedDashboardBlock",
  "abstractKey": null
},
v95 = {
  "alias": "curriculumTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v96 = {
  "alias": "curriculumView",
  "args": null,
  "kind": "ScalarField",
  "name": "view",
  "storageKey": null
},
v97 = {
  "kind": "InlineFragment",
  "selections": [
    (v95/*: any*/),
    (v96/*: any*/)
  ],
  "type": "CurriculumDashboardBlock",
  "abstractKey": null
},
v98 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "channelsTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "ChannelsDashboardBlock",
  "abstractKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAvailability",
  "storageKey": null
},
v100 = {
  "kind": "InlineFragment",
  "selections": [
    (v88/*: any*/),
    (v69/*: any*/),
    (v70/*: any*/),
    (v99/*: any*/)
  ],
  "type": "BannerDashboardBlock",
  "abstractKey": null
},
v101 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    (v58/*: any*/)
  ],
  "type": "CommunityWelcomeHeroDashboardBlock",
  "abstractKey": null
},
v102 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/)
  ],
  "type": "ContinueYourProductsDashboardBlock",
  "abstractKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v104 = {
  "alias": "memberCount",
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v105 = {
  "kind": "InlineFragment",
  "selections": [
    (v88/*: any*/),
    (v69/*: any*/),
    (v70/*: any*/),
    (v99/*: any*/),
    (v54/*: any*/)
  ],
  "type": "BannerDashboardBlock",
  "abstractKey": null
},
v106 = {
  "kind": "InlineFragment",
  "selections": [
    (v58/*: any*/),
    (v54/*: any*/)
  ],
  "type": "CommunityWelcomeHeroDashboardBlock",
  "abstractKey": null
},
v107 = {
  "kind": "InlineFragment",
  "selections": [
    (v60/*: any*/)
  ],
  "type": "WelcomeBannerDashboardBlock",
  "abstractKey": null
},
v108 = {
  "kind": "InlineFragment",
  "selections": [
    (v79/*: any*/)
  ],
  "type": "FeaturedItemsDashboardBlock",
  "abstractKey": null
},
v109 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    (v58/*: any*/),
    (v54/*: any*/)
  ],
  "type": "CommunityWelcomeHeroDashboardBlock",
  "abstractKey": null
},
v110 = {
  "kind": "InlineFragment",
  "selections": [
    (v83/*: any*/)
  ],
  "type": "MembersListDashboardBlock",
  "abstractKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showComments",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerBookmarked",
  "storageKey": null
},
v113 = [
  (v8/*: any*/),
  (v4/*: any*/)
],
v114 = [
  (v25/*: any*/),
  (v4/*: any*/)
],
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": (v114/*: any*/),
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entity",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurriculumModule",
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDatetime",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverVideo",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCoverPlayIcon",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCollectionModule",
  "storageKey": null
},
v125 = [
  (v45/*: any*/)
],
v126 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentLikeNodeConnection",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": (v125/*: any*/),
  "storageKey": null
},
v127 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v128 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentReactionConnection",
  "kind": "LinkedField",
  "name": "uniqueReactions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentReactionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentReaction",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasViewerReacted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emojiCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emojiAlias",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emojiCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v127/*: any*/)
  ],
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalComments",
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerCommented",
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v132 = [
  (v4/*: any*/),
  (v25/*: any*/)
],
v133 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releasedAt",
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v136 = {
  "kind": "InlineFragment",
  "selections": [
    (v74/*: any*/)
  ],
  "type": "ContentDashboardBlock",
  "abstractKey": null
},
v137 = {
  "kind": "InlineFragment",
  "selections": [
    (v87/*: any*/)
  ],
  "type": "UpcomingEventsDashboardBlock",
  "abstractKey": null
},
v138 = {
  "kind": "InlineFragment",
  "selections": [
    (v69/*: any*/),
    (v70/*: any*/),
    (v99/*: any*/),
    (v54/*: any*/)
  ],
  "type": "BannerDashboardBlock",
  "abstractKey": null
},
v139 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "viewerCanPostInFeeds",
    "storageKey": null
  }
],
v140 = {
  "kind": "InlineFragment",
  "selections": [
    (v91/*: any*/),
    (v93/*: any*/)
  ],
  "type": "FeedDashboardBlock",
  "abstractKey": null
},
v141 = {
  "kind": "InlineFragment",
  "selections": [
    (v95/*: any*/)
  ],
  "type": "CurriculumDashboardBlock",
  "abstractKey": null
},
v142 = {
  "alias": null,
  "args": null,
  "concreteType": "Tag",
  "kind": "LinkedField",
  "name": "typeTag",
  "plural": false,
  "selections": [
    (v119/*: any*/),
    (v15/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v143 = {
  "kind": "InlineFragment",
  "selections": [
    (v55/*: any*/),
    (v7/*: any*/),
    (v56/*: any*/),
    (v107/*: any*/),
    (v136/*: any*/),
    (v108/*: any*/),
    (v81/*: any*/),
    (v82/*: any*/),
    (v110/*: any*/),
    (v137/*: any*/),
    (v140/*: any*/),
    (v141/*: any*/),
    (v98/*: any*/),
    (v102/*: any*/)
  ],
  "type": "DashboardBlock",
  "abstractKey": "__isDashboardBlock"
},
v144 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductAppNodeConnection",
  "kind": "LinkedField",
  "name": "apps",
  "plural": false,
  "selections": (v53/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddAppFormStoreMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v3/*: any*/),
        "concreteType": "CreateProductAppResponse",
        "kind": "LinkedField",
        "name": "createProductApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductApp",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AppSidebarItemFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedAppSettingsButtonFragment"
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Feed",
                "kind": "LinkedField",
                "name": "feed",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badge",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v18/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MyExperiencesListItemFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AppsSidebarList_ProductFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dashboard",
                    "kind": "LinkedField",
                    "name": "dashboard",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": (v19/*: any*/),
                        "concreteType": "DashboardBlockNodeConnection",
                        "kind": "LinkedField",
                        "name": "blocks",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DashboardBlockNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "DashboardBlockItemFragment"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "blocks(position:\"main\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "isOrgTopLevel",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AppsSidebarList_OrganizationFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NavSection",
                "kind": "LinkedField",
                "name": "navSection",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AppsSidebarList_NavSectionFragment"
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useRenderProductAppItemFragment"
              }
            ],
            "storageKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAddAppFormStoreMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v3/*: any*/),
        "concreteType": "CreateProductAppResponse",
        "kind": "LinkedField",
        "name": "createProductApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductApp",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v24/*: any*/),
                  (v18/*: any*/),
                  (v25/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembership",
                    "kind": "LinkedField",
                    "name": "viewerMembership",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "organizationMembershipId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Dashboard",
                        "kind": "LinkedField",
                        "name": "forYouDashboard",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "app",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "waitingRoomEndsAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminCanLearnMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductAppNodeConnection",
                    "kind": "LinkedField",
                    "name": "productApps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductAppNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v9/*: any*/),
                              (v8/*: any*/),
                              (v35/*: any*/),
                              (v41/*: any*/),
                              (v14/*: any*/),
                              (v20/*: any*/),
                              (v43/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v23/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v12/*: any*/),
                              (v50/*: any*/),
                              {
                                "alias": "folderApps",
                                "args": null,
                                "concreteType": "ProductAppNodeConnection",
                                "kind": "LinkedField",
                                "name": "productApps",
                                "plural": false,
                                "selections": (v53/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": "folderApps",
                                "args": null,
                                "filters": null,
                                "handle": "connection",
                                "key": "AppsSidebarList_ProductFragment__folderApps",
                                "kind": "LinkedHandle",
                                "name": "productApps"
                              },
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v51/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v52/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "AppsSidebarList_ProductFragment__productApps",
                    "kind": "LinkedHandle",
                    "name": "productApps"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dashboard",
                    "kind": "LinkedField",
                    "name": "dashboard",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": (v19/*: any*/),
                        "concreteType": "DashboardBlockNodeConnection",
                        "kind": "LinkedField",
                        "name": "blocks",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DashboardBlockNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isDashboardBlock"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "position",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "showWelcomeText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "askAi",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "headerWithMacrosReplaced",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "subText",
                                        "storageKey": null
                                      },
                                      (v15/*: any*/),
                                      {
                                        "alias": "heroMode",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mode",
                                        "storageKey": null
                                      },
                                      (v54/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "textColor",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v57/*: any*/),
                                              (v58/*: any*/),
                                              (v59/*: any*/),
                                              (v60/*: any*/)
                                            ],
                                            "type": "WelcomeBannerDashboardBlock",
                                            "abstractKey": null
                                          },
                                          (v66/*: any*/),
                                          (v73/*: any*/),
                                          (v76/*: any*/),
                                          (v77/*: any*/),
                                          (v80/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v85/*: any*/),
                                          (v90/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v100/*: any*/),
                                          (v101/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "HeroDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v49/*: any*/),
                                      (v103/*: any*/),
                                      (v104/*: any*/),
                                      (v57/*: any*/),
                                      {
                                        "alias": "blockDescription",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "description",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lookbackWindow",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": "blockView",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "view",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v58/*: any*/),
                                              (v59/*: any*/),
                                              (v54/*: any*/),
                                              (v60/*: any*/)
                                            ],
                                            "type": "WelcomeBannerDashboardBlock",
                                            "abstractKey": null
                                          },
                                          (v66/*: any*/),
                                          (v73/*: any*/),
                                          (v76/*: any*/),
                                          (v77/*: any*/),
                                          (v80/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v85/*: any*/),
                                          (v90/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v105/*: any*/),
                                          (v106/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "LeaderboardDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v57/*: any*/),
                                      (v58/*: any*/),
                                      (v59/*: any*/),
                                      (v54/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Organization",
                                        "kind": "LinkedField",
                                        "name": "organization",
                                        "plural": false,
                                        "selections": [
                                          (v54/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v66/*: any*/),
                                          (v73/*: any*/),
                                          (v76/*: any*/),
                                          (v77/*: any*/),
                                          (v80/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v85/*: any*/),
                                          (v90/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v100/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "WelcomeBannerDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v56/*: any*/),
                                      (v70/*: any*/),
                                      (v78/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Dashboard",
                                        "kind": "LinkedField",
                                        "name": "dashboard",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "layout",
                                            "storageKey": null
                                          },
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Organization",
                                        "kind": "LinkedField",
                                        "name": "organization",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "kind": "LinkedField",
                                            "name": "viewerMembershipPlan",
                                            "plural": false,
                                            "selections": (v13/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v66/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v67/*: any*/),
                                              (v68/*: any*/),
                                              (v69/*: any*/),
                                              (v71/*: any*/),
                                              (v72/*: any*/)
                                            ],
                                            "type": "ExperienceDetailsDashboardBlock",
                                            "abstractKey": null
                                          },
                                          (v76/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v85/*: any*/),
                                          (v90/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v88/*: any*/),
                                              (v69/*: any*/),
                                              (v99/*: any*/),
                                              (v54/*: any*/)
                                            ],
                                            "type": "BannerDashboardBlock",
                                            "abstractKey": null
                                          },
                                          (v109/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "FeaturedItemsDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v49/*: any*/),
                                      (v103/*: any*/),
                                      (v84/*: any*/),
                                      (v104/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v66/*: any*/),
                                          (v73/*: any*/),
                                          (v76/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v90/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v105/*: any*/),
                                          (v109/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "MembersListDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v61/*: any*/),
                                      (v62/*: any*/),
                                      (v63/*: any*/),
                                      (v64/*: any*/),
                                      (v65/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v73/*: any*/),
                                          (v76/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v90/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v105/*: any*/),
                                          (v109/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "RichTextDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mode",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeConnection",
                                        "kind": "LinkedField",
                                        "name": "contentUsages",
                                        "plural": false,
                                        "selections": [
                                          (v45/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsageNodeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ContentUsage",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v111/*: any*/),
                                                  (v112/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProductApp",
                                                    "kind": "LinkedField",
                                                    "name": "productApp",
                                                    "plural": false,
                                                    "selections": [
                                                      (v8/*: any*/),
                                                      (v4/*: any*/),
                                                      (v5/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "module",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentUsageNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "usages",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentUsageNodeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ContentUsage",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v4/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductApp",
                                                                    "kind": "LinkedField",
                                                                    "name": "productApp",
                                                                    "plural": false,
                                                                    "selections": (v113/*: any*/),
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Collection",
                                                                    "kind": "LinkedField",
                                                                    "name": "collection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "ProductApp",
                                                                        "kind": "LinkedField",
                                                                        "name": "app",
                                                                        "plural": false,
                                                                        "selections": (v113/*: any*/),
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Curriculum",
                                                                    "kind": "LinkedField",
                                                                    "name": "curriculum",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      (v115/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v116/*: any*/),
                                                                  (v117/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v4/*: any*/),
                                                      (v118/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentUsageNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "children",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentUsageNodeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ContentUsage",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v4/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Content",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      (v24/*: any*/),
                                                                      (v25/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "systemTaskKind",
                                                                        "storageKey": null
                                                                      },
                                                                      (v119/*: any*/),
                                                                      (v120/*: any*/),
                                                                      (v121/*: any*/),
                                                                      (v122/*: any*/),
                                                                      (v123/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v124/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                      (v4/*: any*/),
                                                      (v24/*: any*/),
                                                      (v119/*: any*/),
                                                      (v25/*: any*/),
                                                      (v67/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "coverPhoto",
                                                        "storageKey": null
                                                      },
                                                      (v121/*: any*/),
                                                      (v122/*: any*/),
                                                      (v123/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "AssetUsage",
                                                        "kind": "LinkedField",
                                                        "name": "coverVideoAssetUsage",
                                                        "plural": false,
                                                        "selections": [
                                                          (v4/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Asset",
                                                            "kind": "LinkedField",
                                                            "name": "asset",
                                                            "plural": false,
                                                            "selections": [
                                                              (v4/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "url",
                                                                "storageKey": null
                                                              },
                                                              (v25/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "muxAssetPlaybackId",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "aspectRatio",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "videoDuration",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v48/*: any*/),
                                                      (v112/*: any*/),
                                                      (v111/*: any*/),
                                                      (v126/*: any*/),
                                                      (v128/*: any*/),
                                                      (v129/*: any*/),
                                                      (v130/*: any*/),
                                                      (v118/*: any*/),
                                                      {
                                                        "alias": "allChildren",
                                                        "args": null,
                                                        "concreteType": "ContentUsageNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "children",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentUsageNodeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ContentUsage",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v13/*: any*/),
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "User",
                                                        "kind": "LinkedField",
                                                        "name": "createdBy",
                                                        "plural": false,
                                                        "selections": [
                                                          (v4/*: any*/),
                                                          (v131/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "avatar",
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isTest",
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Product",
                                                        "kind": "LinkedField",
                                                        "name": "product",
                                                        "plural": false,
                                                        "selections": [
                                                          (v25/*: any*/),
                                                          (v18/*: any*/),
                                                          (v4/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "releaseDatetime",
                                                        "storageKey": null
                                                      },
                                                      (v120/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Post",
                                                        "kind": "LinkedField",
                                                        "name": "post",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Feed",
                                                            "kind": "LinkedField",
                                                            "name": "feed",
                                                            "plural": false,
                                                            "selections": (v132/*: any*/),
                                                            "storageKey": null
                                                          },
                                                          (v133/*: any*/),
                                                          (v4/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "richEditorDescriptionContent",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentMentionNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "mentions",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentMentionNodeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ContentMention",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v4/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      (v131/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "MemberGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "memberGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      (v25/*: any*/),
                                                                      (v5/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "role",
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Product",
                                                                    "kind": "LinkedField",
                                                                    "name": "mentionedProduct",
                                                                    "plural": false,
                                                                    "selections": (v132/*: any*/),
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ContentUsage",
                                                                    "kind": "LinkedField",
                                                                    "name": "mentionedContentUsage",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "Content",
                                                                        "kind": "LinkedField",
                                                                        "name": "content",
                                                                        "plural": false,
                                                                        "selections": (v132/*: any*/),
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Occurrence",
                                                                    "kind": "LinkedField",
                                                                    "name": "mentionedOccurrence",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      (v25/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "Content",
                                                                        "kind": "LinkedField",
                                                                        "name": "content",
                                                                        "plural": false,
                                                                        "selections": (v114/*: any*/),
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v127/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentAttachmentNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "attachments",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentAttachmentNodeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "ContentAttachment",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v4/*: any*/),
                                                                  (v25/*: any*/),
                                                                  (v24/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "downloadUrl",
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "videoUrl",
                                                                    "storageKey": null
                                                                  },
                                                                  (v17/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v134/*: any*/),
                                                  (v116/*: any*/),
                                                  (v117/*: any*/),
                                                  (v48/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentUsageNodeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "dependents",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentUsageNodeEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentUsage",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v4/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Content",
                                                                "kind": "LinkedField",
                                                                "name": "content",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v118/*: any*/),
                                                                  (v4/*: any*/),
                                                                  (v24/*: any*/),
                                                                  (v119/*: any*/),
                                                                  (v25/*: any*/),
                                                                  (v120/*: any*/),
                                                                  (v121/*: any*/),
                                                                  (v122/*: any*/),
                                                                  (v123/*: any*/),
                                                                  (v67/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ContentUsageNodeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "children",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v45/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "ContentUsageNodeEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                          {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ContentUsage",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v4/*: any*/),
                                                                              (v135/*: any*/),
                                                                              {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "Content",
                                                                                "kind": "LinkedField",
                                                                                "name": "content",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v24/*: any*/),
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "contentLabelId",
                                                                                    "storageKey": null
                                                                                  },
                                                                                  (v4/*: any*/)
                                                                                ],
                                                                                "storageKey": null
                                                                              }
                                                                            ],
                                                                            "storageKey": null
                                                                          }
                                                                        ],
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v133/*: any*/),
                                                              (v135/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "dueAt",
                                                                "storageKey": null
                                                              },
                                                              (v116/*: any*/),
                                                              (v115/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Content",
                                                                "kind": "LinkedField",
                                                                "name": "module",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v118/*: any*/),
                                                                  (v124/*: any*/),
                                                                  (v25/*: any*/),
                                                                  (v4/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v134/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "passPercentage",
                                                                "storageKey": null
                                                              },
                                                              (v117/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v75/*: any*/),
                                                  (v126/*: any*/),
                                                  (v128/*: any*/),
                                                  (v129/*: any*/),
                                                  (v130/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Product",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": (v42/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v7/*: any*/),
                                          (v56/*: any*/),
                                          (v107/*: any*/),
                                          (v73/*: any*/),
                                          (v136/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v90/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v105/*: any*/),
                                          (v109/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "ContentDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v67/*: any*/),
                                      (v68/*: any*/),
                                      (v69/*: any*/),
                                      (v70/*: any*/),
                                      (v71/*: any*/),
                                      (v72/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v90/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v88/*: any*/),
                                              (v99/*: any*/),
                                              (v54/*: any*/)
                                            ],
                                            "type": "BannerDashboardBlock",
                                            "abstractKey": null
                                          },
                                          (v109/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "ExperienceDetailsDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v89/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v88/*: any*/),
                                      (v86/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "view",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v137/*: any*/),
                                          (v94/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v138/*: any*/),
                                          (v109/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "UpcomingEventsDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v92/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Dashboard",
                                        "kind": "LinkedField",
                                        "name": "dashboard",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductApp",
                                            "kind": "LinkedField",
                                            "name": "app",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Feed",
                                                "kind": "LinkedField",
                                                "name": "feed",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v39/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isInactive",
                                                    "storageKey": null
                                                  },
                                                  (v48/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProductApp",
                                                    "kind": "LinkedField",
                                                    "name": "app",
                                                    "plural": false,
                                                    "selections": [
                                                      (v4/*: any*/),
                                                      (v10/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "customAppDescription",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Product",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                      (v39/*: any*/),
                                                      (v4/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v4/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v4/*: any*/),
                                          (v39/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v57/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "filter",
                                        "storageKey": null
                                      },
                                      (v56/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Organization",
                                        "kind": "LinkedField",
                                        "name": "organization",
                                        "plural": false,
                                        "selections": (v139/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Product",
                                        "kind": "LinkedField",
                                        "name": "product",
                                        "plural": false,
                                        "selections": (v139/*: any*/),
                                        "storageKey": null
                                      },
                                      (v88/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v137/*: any*/),
                                          (v140/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v138/*: any*/),
                                          (v106/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "FeedDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v96/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v57/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v7/*: any*/),
                                          (v56/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v137/*: any*/),
                                          (v140/*: any*/),
                                          (v141/*: any*/),
                                          (v98/*: any*/),
                                          (v105/*: any*/),
                                          (v106/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "CurriculumDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v48/*: any*/),
                                      (v57/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v137/*: any*/),
                                          (v140/*: any*/),
                                          (v141/*: any*/),
                                          (v98/*: any*/),
                                          (v105/*: any*/),
                                          (v106/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "ChannelsDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v88/*: any*/),
                                      (v54/*: any*/),
                                      (v69/*: any*/),
                                      (v70/*: any*/),
                                      (v99/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Product",
                                        "kind": "LinkedField",
                                        "name": "product",
                                        "plural": false,
                                        "selections": [
                                          (v142/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v77/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v137/*: any*/),
                                          (v140/*: any*/),
                                          (v141/*: any*/),
                                          (v98/*: any*/),
                                          (v101/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "BannerDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Content",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": (v13/*: any*/),
                                        "storageKey": null
                                      },
                                      (v75/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v7/*: any*/),
                                          (v56/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v137/*: any*/),
                                          (v140/*: any*/),
                                          (v141/*: any*/),
                                          (v98/*: any*/),
                                          (v109/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "CollectionFolderDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v57/*: any*/),
                                      (v58/*: any*/),
                                      (v54/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Organization",
                                        "kind": "LinkedField",
                                        "name": "organization",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "plans",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "hideDrafts",
                                                "value": true
                                              },
                                              {
                                                "kind": "Literal",
                                                "name": "type",
                                                "value": "membership_plan"
                                              }
                                            ],
                                            "concreteType": "ProductNodeConnection",
                                            "kind": "LinkedField",
                                            "name": "products",
                                            "plural": false,
                                            "selections": (v125/*: any*/),
                                            "storageKey": "products(hideDrafts:true,type:\"membership_plan\")"
                                          },
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "kind": "LinkedField",
                                            "name": "viewerMembershipPlan",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ChangeMembershipPlan",
                                                "kind": "LinkedField",
                                                "name": "viewerCanChangeMembershipPlan",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "value",
                                                    "storageKey": null
                                                  },
                                                  (v21/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v137/*: any*/),
                                          (v140/*: any*/),
                                          (v141/*: any*/),
                                          (v98/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "CommunityWelcomeHeroDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v48/*: any*/),
                                      (v69/*: any*/),
                                      (v70/*: any*/),
                                      (v99/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Product",
                                        "kind": "LinkedField",
                                        "name": "product",
                                        "plural": false,
                                        "selections": [
                                          (v24/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductNodeConnection",
                                            "kind": "LinkedField",
                                            "name": "childProducts",
                                            "plural": false,
                                            "selections": (v125/*: any*/),
                                            "storageKey": null
                                          },
                                          (v142/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/),
                                          (v56/*: any*/),
                                          (v7/*: any*/),
                                          (v107/*: any*/),
                                          (v136/*: any*/),
                                          (v108/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v110/*: any*/),
                                          (v137/*: any*/),
                                          (v140/*: any*/),
                                          (v141/*: any*/),
                                          (v98/*: any*/),
                                          (v102/*: any*/)
                                        ],
                                        "type": "DashboardBlock",
                                        "abstractKey": "__isDashboardBlock"
                                      }
                                    ],
                                    "type": "ProductAdminDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v48/*: any*/),
                                      (v143/*: any*/)
                                    ],
                                    "type": "PathwaySequenceDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductNodeConnection",
                                        "kind": "LinkedField",
                                        "name": "products",
                                        "plural": false,
                                        "selections": (v125/*: any*/),
                                        "storageKey": null
                                      },
                                      (v143/*: any*/)
                                    ],
                                    "type": "ContinueYourProductsDashboardBlock",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v143/*: any*/)
                                    ],
                                    "type": "RecentlyViewedDashboardBlock",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "blocks(position:\"main\")"
                      }
                    ],
                    "storageKey": null
                  },
                  (v40/*: any*/),
                  (v39/*: any*/)
                ],
                "storageKey": null
              },
              (v47/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "appendNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "feed",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "FeedNodeEdge"
                  }
                ]
              },
              (v14/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NavSection",
                "kind": "LinkedField",
                "name": "navSection",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v144/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "AppsSidebarList_NavSectionFragment__apps",
                    "kind": "LinkedHandle",
                    "name": "apps"
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/),
              (v43/*: any*/),
              (v46/*: any*/),
              (v50/*: any*/),
              {
                "condition": "isOrgTopLevel",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v144/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "filters": null,
                        "handle": "connection",
                        "key": "AppsSidebarList_OrganizationFragment__apps",
                        "kind": "LinkedHandle",
                        "name": "apps"
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9a328931cd89b96c4327eff321e1ec70",
    "id": null,
    "metadata": {},
    "name": "useAddAppFormStoreMutation",
    "operationKind": "mutation",
    "text": "mutation useAddAppFormStoreMutation(\n  $input: CreateProductAppInput!\n  $isOrgTopLevel: Boolean = false\n) {\n  response: createProductApp(input: $input) {\n    node {\n      id\n      kind\n      status\n      ordering\n      customAppTitle\n      customAppUrl\n      visibility\n      showOnDashboard\n      ...AppSidebarItemFragment\n      ...FeedAppSettingsButtonFragment\n      navSectionId\n      feed {\n        id\n      }\n      collection {\n        id\n      }\n      badge {\n        kind\n        color\n        emoji\n        mediaUrl\n        id\n      }\n      product {\n        id\n        slug\n        ...MyExperiencesListItemFragment\n        ...AppsSidebarList_ProductFragment\n        dashboard {\n          id\n          blocks(position: main) {\n            edges {\n              node {\n                __typename\n                id\n                kind\n                ...DashboardBlockItemFragment\n              }\n            }\n          }\n        }\n      }\n      organization @include(if: $isOrgTopLevel) {\n        ...AppsSidebarList_OrganizationFragment\n        id\n      }\n      navSection {\n        ...AppsSidebarList_NavSectionFragment\n        id\n      }\n      contentUsage {\n        id\n      }\n      ...useRenderProductAppItemFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AIFeedEmptyStateFragment on Feed {\n  id\n  productId\n  app {\n    id\n    visibility\n    customAppDescription\n    ...FeedAppSettingsButtonFragment\n  }\n  product {\n    ...usePermissionsFragment\n    id\n  }\n}\n\nfragment AppSidebarItemFragment on ProductApp {\n  kind\n  status\n  visibility\n  customAppTitle\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  forYouDashboard {\n    id\n  }\n  ...RemoveAppButtonFragment\n  ...ToggleAppStatusButtonFragment\n}\n\nfragment AppUtils_getLocationFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  product {\n    slug\n    id\n  }\n  feed {\n    id\n  }\n  chatChannel {\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n}\n\nfragment AppsSidebarDragDropProvider_OrganizationFragment on Organization {\n  id\n  forYouDashboard {\n    app {\n      id\n    }\n    id\n  }\n}\n\nfragment AppsSidebarList_NavSectionFragment on NavSection {\n  id\n  apps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AppsSidebarList_OrganizationFragment on Organization {\n  id\n  apps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AppsSidebarList_ProductFragment on Product {\n  id\n  productApps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        folderApps: productApps {\n          edges {\n            node {\n              id\n              kind\n              customAppUrl\n              customAppTitle\n              feed {\n                id\n                name\n                viewerPermissions\n                ...usePermissionsFragment\n              }\n              product {\n                slug\n                name\n                ...usePermissionsFragment\n                ...appLevelContextFragment\n                id\n              }\n              collection {\n                id\n              }\n              contentUsage {\n                id\n              }\n              linkProduct {\n                slug\n                id\n              }\n              productApps {\n                edges {\n                  node {\n                    id\n                    chatChannel {\n                      externalChannelId\n                      id\n                    }\n                  }\n                }\n              }\n              forYouDashboard {\n                id\n              }\n              ...AppSidebarItemFragment\n              ...ContentAppSettingsButtonFragment\n              ...LinkAppSettingsButtonFragment\n              ...FeedAppSettingsButtonFragment\n              ...GenericAppSettingsButtonFragment\n              ...CollectionAppSettingsButtonFragment\n              ...ChatChannelSettingsModalButtonFragment\n              ...ChatChannelSideBarItemFragment\n              ...NavFolderSettingsDropdownFragment\n              ...EventsAppSettingsButtonFragment\n              ...MembersAppSettingsButtonFragment\n              ...DashboardAppSettingsButtonFragment\n              ...AppUtils_getLocationFragment\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment BannerDashboardBlockFragment on BannerDashboardBlock {\n  id\n  showCover\n  cover\n  ...DashboardBlockAdminDropdownFragment\n  ...ExperienceInfoToolbarFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment BookmarkButtonContentFragment on Content {\n  id\n  hasViewerBookmarked\n}\n\nfragment BookmarkButtonContentUsageFragment on ContentUsage {\n  id\n  hasViewerBookmarked\n}\n\nfragment ChannelsDashboardBlockFragment on ChannelsDashboardBlock {\n  productId\n  title\n  position\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment ChatChannelBadgeFragment on ProductApp {\n  badge {\n    ...BadgeFragment\n    id\n  }\n  chatChannel {\n    visibility\n    id\n  }\n}\n\nfragment ChatChannelSettingsModalButtonFragment on ProductApp {\n  id\n  productId\n}\n\nfragment ChatChannelSideBarItemFragment on ProductApp {\n  id\n  customAppTitle\n  chatChannel {\n    id\n    externalChannelId\n    ...usePermissionsFragment\n  }\n  product {\n    slug\n    name\n    viewerMembership {\n      id\n    }\n    id\n  }\n  ...ChatChannelBadgeFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...DeleteChatChannelAppButtonFragment\n  ...AppUtils_getLocationFragment\n}\n\nfragment CollectionAppSettingsButtonFragment on ProductApp {\n  id\n  ...CollectionAppSettingsModalFragment\n}\n\nfragment CollectionAppSettingsModalFragment on ProductApp {\n  id\n}\n\nfragment CollectionFolderDashboardBlockContentFragment on CollectionFolderDashboardBlock {\n  position\n  contentId\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment CollectionFolderDashboardBlockFragment on CollectionFolderDashboardBlock {\n  content {\n    id\n  }\n  ...DashboardBlockItemTemplateFragment\n  ...CollectionFolderDashboardBlockContentFragment\n}\n\nfragment CommentUtils_useTotalCommentsCount on Content {\n  totalComments\n}\n\nfragment CommentUtils_useTotalCommentsOnUsageCount on ContentUsage {\n  totalComments\n}\n\nfragment CommunityWelcomeHeroDashboardBlockFragment on CommunityWelcomeHeroDashboardBlock {\n  title\n  subtitle\n  cover\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  organization {\n    plans: products(type: \"membership_plan\", hideDrafts: true) {\n      totalCount\n    }\n    ...MembershipPlanSelectButton_OrganizationFragment\n    id\n  }\n}\n\nfragment ContentAppSettingsButtonFragment on ProductApp {\n  id\n  ...ContentAppSetupModalFragment\n}\n\nfragment ContentAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment ContentAttachmentsSectionFragment on Content {\n  attachments {\n    edges {\n      node {\n        id\n        name\n        type\n        downloadUrl\n        videoUrl\n        mediaUrl\n      }\n    }\n  }\n}\n\nfragment ContentCard_ContentFragment on Content {\n  id\n  coverVideo\n  coverVideoAssetUsage {\n    id\n    asset {\n      id\n      ...DiscoVideoFragment\n    }\n  }\n  coverPhoto\n  thumbnailUrl\n  showCoverPlayIcon\n  ...ContentHeaderSectionFragment\n  ...ContentMediaSectionFragment\n  ...ContentTitleSectionFragment\n  ...ContentDescriptionSectionFragment\n  ...ContentAttachmentsSectionFragment\n  ...ContentFooterSection_ContentFragment\n  ...BookmarkButtonContentFragment\n}\n\nfragment ContentCard_ContentUsageFragment on ContentUsage {\n  id\n  ...ContentFooterSection_ContentUsageFragment\n}\n\nfragment ContentCommentButton_ContentFragment on Content {\n  ...CommentUtils_useTotalCommentsCount\n  hasViewerCommented\n}\n\nfragment ContentCommentButton_ContentUsageFragment on ContentUsage {\n  ...CommentUtils_useTotalCommentsOnUsageCount\n  hasViewerCommented\n}\n\nfragment ContentDashboardBlockAdminDropdownFragment on ContentDashboardBlock {\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment ContentDashboardBlockFragment on ContentDashboardBlock {\n  mode\n  contentUsages {\n    totalCount\n  }\n  ...DashboardBlockItemTemplateFragment\n  ...ContentDashboardBlockPreviewContentFragment\n  ...ContentDashboardBlockFullContentFragment\n}\n\nfragment ContentDashboardBlockFullContentFragment on ContentDashboardBlock {\n  contentUsages {\n    edges {\n      node {\n        id\n        ...ContentCard_ContentUsageFragment\n        content {\n          id\n          coverPhoto\n          coverVideo\n          coverVideoAssetUsage {\n            id\n            asset {\n              id\n              ...DiscoVideoFragment\n            }\n          }\n          ...ContentCard_ContentFragment\n          ...ContentTitleSectionFragment\n        }\n      }\n    }\n  }\n  ...ContentDashboardBlockAdminDropdownFragment\n}\n\nfragment ContentDashboardBlockPreviewContentFragment on ContentDashboardBlock {\n  position\n  contentUsages {\n    edges {\n      node {\n        id\n        ...ContentUsageGridItemFragment\n      }\n    }\n  }\n  ...ContentDashboardBlockAdminDropdownFragment\n}\n\nfragment ContentDescriptionSectionFragment on Content {\n  id\n  richEditorDescriptionContent\n  type\n  ...DiscoEditorMentionsFragment\n}\n\nfragment ContentFooterSection_ContentFragment on Content {\n  id\n  hasViewerBookmarked\n  showComments\n  ...ContentReactionButton_ContentFragment\n  ...ContentCommentButton_ContentFragment\n  ...BookmarkButtonContentFragment\n}\n\nfragment ContentFooterSection_ContentUsageFragment on ContentUsage {\n  id\n  contentId\n  hasViewerBookmarked\n  showComments\n  ...ContentReactionButton_ContentUsageFragment\n  ...ContentCommentButton_ContentUsageFragment\n  ...BookmarkButtonContentUsageFragment\n}\n\nfragment ContentHeaderSectionFragment on Content {\n  id\n  type\n  createdBy {\n    id\n    ...ProfileAvatarWithDetailsFragment\n  }\n  product {\n    name\n    slug\n    id\n  }\n  releaseDatetime\n  creationDatetime\n  post {\n    feed {\n      id\n      name\n    }\n    releasedAt\n    id\n  }\n}\n\nfragment ContentMediaSectionFragment on Content {\n  id\n  coverPhoto\n  coverVideo\n  coverVideoAssetUsage {\n    id\n    asset {\n      id\n      ...DiscoVideoFragment\n    }\n  }\n}\n\nfragment ContentReactionButton_ContentFragment on Content {\n  id\n  likes {\n    totalCount\n  }\n  uniqueReactions {\n    edges {\n      node {\n        id\n        hasViewerReacted\n        emojiCode\n        emojiAlias\n        emojiCount\n      }\n    }\n  }\n}\n\nfragment ContentReactionButton_ContentUsageFragment on ContentUsage {\n  id\n  likes {\n    totalCount\n  }\n  uniqueReactions {\n    edges {\n      node {\n        id\n        hasViewerReacted\n        emojiCode\n        emojiAlias\n        emojiCount\n      }\n    }\n  }\n}\n\nfragment ContentThumbnailWithDetails_ContentFragment on Content {\n  id\n  type\n  label\n  name\n  creationDatetime\n  ...ContentThumbnail_ContentFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentUsageFragment on ContentUsage {\n  id\n  dueAt\n  entity\n  product {\n    name\n    id\n  }\n  module {\n    isCurriculumModule\n    isCollectionModule\n    name\n    id\n  }\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment ContentTitleSectionFragment on Content {\n  id\n  name\n}\n\nfragment ContentUsageGridItemFragment on ContentUsage {\n  id\n  showComments\n  hasViewerBookmarked\n  productApp {\n    customAppTitle\n    id\n  }\n  ...BookmarkButtonContentUsageFragment\n  module {\n    usages {\n      edges {\n        node {\n          id\n          productApp {\n            customAppTitle\n            id\n          }\n          collection {\n            id\n            app {\n              customAppTitle\n              id\n            }\n          }\n          curriculum {\n            id\n            product {\n              name\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  content {\n    id\n    type\n    label\n    name\n    description\n    coverPhoto\n    coverVideo\n    thumbnailUrl\n    showCoverPlayIcon\n    coverVideoAssetUsage {\n      id\n      asset {\n        id\n        ...DiscoVideoFragment\n      }\n    }\n    productId\n    ...ContentFooterSection_ContentFragment\n    ...BookmarkButtonContentFragment\n  }\n  ...DeleteContentUsageButtonFragment\n  ...ContentFooterSection_ContentUsageFragment\n  ...ContentUsageUtils_useContentUsagePathContentUsageFragment\n}\n\nfragment ContentUsagePrerequisiteItemFragment on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  ...ContentThumbnailWithDetails_ContentUsageFragment\n  isLocked\n  passPercentage\n  content {\n    id\n    isCurriculumModule\n    ...ContentThumbnailWithDetails_ContentFragment\n    name\n    type\n    description\n    children {\n      totalCount\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          content {\n            type\n            contentLabelId\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContentUsageUtils_UseParentEntityContentUsageFragment on ContentUsage {\n  id\n  entity\n  module {\n    isCurriculumModule\n    isCollectionModule\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n}\n\nfragment ContentUsageUtils_useContentUsagePathContentUsageFragment on ContentUsage {\n  id\n  entity\n  entityId\n  product {\n    slug\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n  module {\n    usages {\n      edges {\n        node {\n          id\n          entity\n          entityId\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContentUsageUtils_useNavigateToNextContentUsageFragment on ContentUsage {\n  id\n  module {\n    children {\n      edges {\n        node {\n          id\n          content {\n            id\n            type\n            name\n            systemTaskKind\n            ...ContentThumbnailWithDetails_ContentFragment\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContinueYourProductsDashboardBlockFragment on ContinueYourProductsDashboardBlock {\n  id\n  position\n  products {\n    totalCount\n  }\n  ...DashboardBlockItemTemplateFragment\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment CurriculumDashboardBlockCardViewFragment on CurriculumDashboardBlock {\n  productId\n  organizationId\n  position\n  title\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment CurriculumDashboardBlockFragment on CurriculumDashboardBlock {\n  curriculumView: view\n  ...DashboardBlockItemTemplateFragment\n  ...CurriculumDashboardBlockCardViewFragment\n  ...CurriculumDashboardBlockListViewFragment\n}\n\nfragment CurriculumDashboardBlockListViewFragment on CurriculumDashboardBlock {\n  productId\n  title\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment DashboardAppSettingsButtonFragment on ProductApp {\n  id\n  ...DashboardAppSetupModalFragment\n}\n\nfragment DashboardAppSetupModalContentFragment on ProductApp {\n  id\n  forYouDashboard {\n    id\n  }\n}\n\nfragment DashboardAppSetupModalFragment on ProductApp {\n  customAppTitle\n  forYouDashboard {\n    id\n  }\n  ...DashboardAppSetupModalContentFragment\n}\n\nfragment DashboardBlockAdminDropdownFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  id\n  position\n  kind\n  ...EditDashboardBlockButtonFragment\n}\n\nfragment DashboardBlockItemFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  id\n  kind\n  position\n  ...HeroDashboardBlockFragment\n  ...LeaderboardDashboardBlockFragment\n  ...WelcomeBannerDashboardBlockFragment\n  ...FeaturedItemsDashboardBlockFragment\n  ...MembersDashboardBlockFragment\n  ...RichTextDashboardBlockFragment\n  ...ContentDashboardBlockFragment\n  ...ExperienceDetailsDashboardBlockFragment\n  ...EventsDashboardBlockFragment\n  ...FeedDashboardBlockFragment\n  ...CurriculumDashboardBlockFragment\n  ...ChannelsDashboardBlockFragment\n  ...BannerDashboardBlockFragment\n  ...CollectionFolderDashboardBlockFragment\n  ...CommunityWelcomeHeroDashboardBlockFragment\n  ...ProductAdminDashboardBlockFragment\n  ...PathwaySequenceDashboardBlockFragment\n  ...ContinueYourProductsDashboardBlockFragment\n  ...RecentlyViewedDashboardBlockFragment\n}\n\nfragment DashboardBlockItemTemplateFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  id\n  kind\n  position\n  showOnMobile\n  ordering\n  dashboardId\n  ...DashboardBlockAdminDropdownFragment\n  ... on WelcomeBannerDashboardBlock {\n    hideAfter\n  }\n  ... on FeedDashboardBlock {\n    feedView: view\n  }\n}\n\nfragment DeleteChatChannelAppButtonFragment on ProductApp {\n  id\n  navSectionId\n  product {\n    id\n    slug\n  }\n  chatChannel {\n    id\n    organizationId\n  }\n}\n\nfragment DeleteContentUsageButtonFragment on ContentUsage {\n  id\n  isLocked\n  entity\n  entityId\n  productId\n  dependents {\n    edges {\n      node {\n        id\n        content {\n          isCurriculumModule\n          id\n        }\n        ...ContentUsagePrerequisiteItemFragment\n        ...UpdateContentModuleButtonFragment\n      }\n    }\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  content {\n    type\n    label\n    isCurriculumModule\n    allChildren: children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  productApp {\n    customAppTitle\n    id\n  }\n  ...ContentUsageUtils_useNavigateToNextContentUsageFragment\n  ...ContentUsageUtils_UseParentEntityContentUsageFragment\n}\n\nfragment DeleteNavFolderButtonFragment on ProductApp {\n  id\n  customAppTitle\n  productApps {\n    totalCount\n  }\n}\n\nfragment DiscoEditorMentionsFragment on Content {\n  id\n  ...EditorMentionsProviderFragment\n}\n\nfragment DiscoVideoFragment on Asset {\n  id\n  url\n  name\n  muxAssetPlaybackId\n  aspectRatio\n  videoDuration\n}\n\nfragment EditDashboardBlockButtonFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  kind\n  position\n  ...EditDashboardBlockFormFragment\n}\n\nfragment EditDashboardBlockFormFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  id\n  kind\n  position\n  showOnMobile\n  dashboardId\n  __typename\n  ... on WelcomeBannerDashboardBlock {\n    title\n    subtitle\n    richEditorDescription\n    cover\n    hideAfter\n  }\n  ... on RichTextDashboardBlock {\n    position\n    richTextBlockTitle: title\n    richEditorContent\n    hasCtaButton\n    ctaUrl\n    ctaText\n  }\n  ... on ExperienceDetailsDashboardBlock {\n    description\n    showMembers\n    showDates\n    showCountdown\n    showProgress\n    showAttendance\n  }\n  ... on ContentDashboardBlock {\n    contentMode: mode\n    contentUsages {\n      edges {\n        node {\n          id\n          contentId\n        }\n      }\n    }\n  }\n  ... on CollectionFolderDashboardBlock {\n    contentId\n  }\n  ... on FeaturedItemsDashboardBlock {\n    showCountdown\n    featuredKind\n    featuredProducts {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n  ... on HeroDashboardBlock {\n    heroMode: mode\n    color\n    header\n    headerWithMacrosReplaced\n    subText\n    cover\n    askAi\n    showWelcomeText\n    textColor\n  }\n  ... on LeaderboardDashboardBlock {\n    leaderboardCount: count\n    leaderboardTitle: title\n    leaderboardDescription: description\n    leaderboardLookbackWindow: lookbackWindow\n    leaderboardView: view\n  }\n  ... on MembersListDashboardBlock {\n    membersListCount: count\n    memberType\n  }\n  ... on UpcomingEventsDashboardBlock {\n    count\n    eventType\n    showCover\n    eventsView: view\n  }\n  ... on FeedDashboardBlock {\n    feedTitle: title\n    feedView: view\n    feedShowCover: showCover\n  }\n  ... on CurriculumDashboardBlock {\n    curriculumTitle: title\n    curriculumView: view\n  }\n  ... on ChannelsDashboardBlock {\n    channelsTitle: title\n  }\n  ... on BannerDashboardBlock {\n    showCover\n    showDates\n    showCountdown\n    showAvailability\n    cover\n  }\n  ... on CommunityWelcomeHeroDashboardBlock {\n    title\n    subtitle\n    cover\n  }\n  ... on ContinueYourProductsDashboardBlock {\n    title\n  }\n}\n\nfragment EditorMentionsProviderFragment on Content {\n  id\n  mentions {\n    edges {\n      node {\n        id\n        user {\n          id\n          fullName\n        }\n        memberGroup {\n          id\n          name\n          kind\n          role\n        }\n        mentionedProduct {\n          id\n          name\n        }\n        mentionedContentUsage {\n          id\n          content {\n            id\n            name\n          }\n        }\n        mentionedOccurrence {\n          id\n          name\n          content {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventsAppSettingsButtonFragment on ProductApp {\n  id\n  ...EventsAppSetupModalFragment\n}\n\nfragment EventsAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment EventsDashboardBlockCardViewFragment on UpcomingEventsDashboardBlock {\n  position\n  productId\n  organizationId\n  showCover\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment EventsDashboardBlockFragment on UpcomingEventsDashboardBlock {\n  eventsView: view\n  ...EventsDashboardBlockCardViewFragment\n  ...EventsDashboardBlockListViewFragment\n}\n\nfragment EventsDashboardBlockListViewFragment on UpcomingEventsDashboardBlock {\n  productId\n  organizationId\n  count\n  position\n  view\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment ExperienceAdminDropdownFragment on Product {\n  id\n  slug\n  type\n  name\n  adminCanLearnMode\n  ...LearnModeSwitchFragment\n  ...usePermissionsFragment\n}\n\nfragment ExperienceDetailsDashboardBlockFragment on ExperienceDetailsDashboardBlock {\n  id\n  description\n  showMembers\n  showDates\n  showCountdown\n  showProgress\n  showAttendance\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment ExperienceInfoToolbarFragment on BannerDashboardBlock {\n  id\n  showDates\n  showCountdown\n  showCover\n  showAvailability\n  cover\n  product {\n    ...ProductTypeTagFragment\n    id\n  }\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment FeaturedItemsDashboardBlockFragment on FeaturedItemsDashboardBlock {\n  id\n  position\n  dashboardId\n  showCountdown\n  featuredKind\n  dashboard {\n    layout\n    id\n  }\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  organization {\n    ...MembershipPlanDetailsCard_OrganizationFragment\n    id\n  }\n}\n\nfragment FeedAppSettingsButtonFragment on ProductApp {\n  id\n  ...FeedAppSetupModalFragment\n}\n\nfragment FeedAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment FeedDashboardBlockCardViewFragment on FeedDashboardBlock {\n  title\n  filter\n  id\n  position\n  dashboardId\n  dashboard {\n    ...usePermissionsFragment\n    app {\n      id\n      feed {\n        id\n        ...usePermissionsFragment\n      }\n    }\n    id\n  }\n  organization {\n    id\n    viewerCanPostInFeeds\n  }\n  product {\n    id\n    viewerCanPostInFeeds\n  }\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  ...PostCardFeedDashboardBlockFragment\n}\n\nfragment FeedDashboardBlockFragment on FeedDashboardBlock {\n  position\n  feedView: view\n  dashboard {\n    app {\n      feed {\n        id\n      }\n      id\n    }\n    id\n  }\n  ...FeedDashboardBlockCardViewFragment\n  ...FeedDashboardBlockListViewFragment\n}\n\nfragment FeedDashboardBlockListViewFragment on FeedDashboardBlock {\n  id\n  title\n  filter\n  showCover\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  product {\n    viewerCanPostInFeeds\n    id\n  }\n  dashboard {\n    id\n    ...usePermissionsFragment\n    app {\n      id\n      feed {\n        id\n        isInactive\n        ...AIFeedEmptyStateFragment\n        ...usePermissionsFragment\n      }\n    }\n  }\n  organization {\n    viewerCanPostInFeeds\n    id\n  }\n  ...PostCardFeedDashboardBlockFragment\n}\n\nfragment GenericAppSettingsButtonFragment on ProductApp {\n  id\n  ...GenericAppSettingsModalFragment\n}\n\nfragment GenericAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment HeroDashboardBlockFragment on HeroDashboardBlock {\n  id\n  showWelcomeText\n  askAi\n  headerWithMacrosReplaced\n  subText\n  color\n  heroMode: mode\n  cover\n  textColor\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment LeaderboardDashboardBlockFragment on LeaderboardDashboardBlock {\n  id\n  organizationId\n  product {\n    id\n    slug\n  }\n  memberCount: count\n  title\n  blockDescription: description\n  position\n  lookbackWindow\n  blockView: view\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment LearnModeSwitchFragment on Product {\n  id\n  name\n  status\n  viewerMembership {\n    id\n  }\n}\n\nfragment LeaveProductButtonFragment on Product {\n  name\n  slug\n  type\n  viewerMembership {\n    id\n    organizationMembershipId\n  }\n}\n\nfragment LinkAppSettingsButtonFragment on ProductApp {\n  id\n  ...LinkAppSetupModalFragment\n}\n\nfragment LinkAppSetupModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MemberDirectoryAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MembersAppSettingsButtonFragment on ProductApp {\n  id\n  kind\n  productId\n  ...MemberDirectoryAppSettingsModalFragment\n}\n\nfragment MembersDashboardBlockFragment on MembersListDashboardBlock {\n  id\n  position\n  organizationId\n  product {\n    id\n    slug\n  }\n  memberType\n  memberCount: count\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment MembershipPlanDetailsCard_OrganizationFragment on Organization {\n  id\n  viewerMembershipPlan {\n    id\n  }\n}\n\nfragment MembershipPlanSelectButton_OrganizationFragment on Organization {\n  id\n  viewerMembershipPlan {\n    id\n    viewerCanChangeMembershipPlan {\n      value\n      message\n    }\n  }\n}\n\nfragment MyExperiencesListItemFragment on Product {\n  id\n  name\n  slug\n  status\n  viewerMembership {\n    id\n  }\n  organization {\n    ...AppsSidebarDragDropProvider_OrganizationFragment\n    id\n  }\n  ...ProductBadgeFragment\n  ...usePermissionsFragment\n  ...useIsWaitingRoomEnabledActiveProductFragment\n  ...ExperienceAdminDropdownFragment\n  ...LeaveProductButtonFragment\n  ...LearnModeSwitchFragment\n}\n\nfragment NavFolderSettingsButtonFragment on ProductApp {\n  id\n}\n\nfragment NavFolderSettingsDropdownFragment on ProductApp {\n  id\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  ...NavFolderSettingsButtonFragment\n  ...DeleteNavFolderButtonFragment\n}\n\nfragment PathwaySequenceDashboardBlockFragment on PathwaySequenceDashboardBlock {\n  id\n  productId\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment PostCardFeedDashboardBlockFragment on FeedDashboardBlock {\n  showCover\n  dashboard {\n    id\n    ...usePermissionsFragment\n  }\n}\n\nfragment ProductAdminDashboardBlockFragment on ProductAdminDashboardBlock {\n  id\n  productId\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  ...ProductAdminInfoToolbarFragment\n}\n\nfragment ProductAdminInfoToolbarFragment on ProductAdminDashboardBlock {\n  id\n  showDates\n  showCountdown\n  showAvailability\n  product {\n    type\n    childProducts {\n      totalCount\n    }\n    ...ProductTypeTagFragment\n    id\n  }\n}\n\nfragment ProductBadgeFragment on Product {\n  id\n  badge {\n    ...BadgeFragment\n    id\n  }\n}\n\nfragment ProductTypeTagFragment on Product {\n  typeTag {\n    label\n    color\n    id\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileAvatarWithDetailsFragment on User {\n  id\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment RecentlyViewedDashboardBlockFragment on RecentlyViewedDashboardBlock {\n  id\n  position\n  ...DashboardBlockItemTemplateFragment\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment RemoveAppButtonFragment on ProductApp {\n  id\n  kind\n  customAppTitle\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  productId\n  organizationId\n  navSectionId\n}\n\nfragment RichTextDashboardBlockFragment on RichTextDashboardBlock {\n  position\n  richTextBlockTitle: title\n  richEditorContent\n  hasCtaButton\n  ctaUrl\n  ctaText\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment ToggleAppStatusButtonFragment on ProductApp {\n  id\n  status\n  kind\n  product {\n    type\n    id\n  }\n}\n\nfragment UpdateContentModuleButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment WelcomeBannerDashboardBlockFragment on WelcomeBannerDashboardBlock {\n  title\n  subtitle\n  richEditorDescription\n  cover\n  organization {\n    cover\n    id\n  }\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment appLevelContextFragment on Product {\n  id\n  name\n  slug\n  type\n  ...useConnectedProductAppsActiveProductFragment\n}\n\nfragment useConnectedProductAppsActiveProductFragment on Product {\n  connectedApps: productApps(includeNested: true) {\n    edges {\n      node {\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment useIsWaitingRoomEnabledActiveProductFragment on Product {\n  waitingRoomEndsAt\n  startDate\n  ...usePermissionsFragment\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n\nfragment useRenderProductAppItemFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  customAppTitle\n  feed {\n    id\n    name\n    viewerPermissions\n    ...usePermissionsFragment\n  }\n  product {\n    slug\n    name\n    ...usePermissionsFragment\n    ...appLevelContextFragment\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n  productApps {\n    edges {\n      node {\n        id\n        chatChannel {\n          externalChannelId\n          id\n        }\n      }\n    }\n  }\n  forYouDashboard {\n    id\n  }\n  ...AppSidebarItemFragment\n  ...ContentAppSettingsButtonFragment\n  ...LinkAppSettingsButtonFragment\n  ...FeedAppSettingsButtonFragment\n  ...GenericAppSettingsButtonFragment\n  ...CollectionAppSettingsButtonFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...ChatChannelSideBarItemFragment\n  ...NavFolderSettingsDropdownFragment\n  ...EventsAppSettingsButtonFragment\n  ...MembersAppSettingsButtonFragment\n  ...DashboardAppSettingsButtonFragment\n  ...AppUtils_getLocationFragment\n}\n"
  }
};
})();

(node as any).hash = "226004d00ea6718ad97551f06fb6f376";

export default node;
